import type { FaireProductEntity } from "../../entity_types/product";

export const p_3pc7n75222: FaireProductEntity = {
  token: "p_3pc7n75222",
  type: "product",
  name: "Santal Candle",
  brandToken: "b_7ltlwh1w",
  brandName: "True Hue",
  imageUrl:
    "https://cdn.faire.com/fastly/40bee6506f1817b5f5d06cdbb3085dbd158d0ce0af48dd682707aebe554786c4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7840ba228395c21cbdd83a0885f509a3889fecff9c80e6367d365c4ec22b7a2.jpeg",
    "https://cdn.faire.com/fastly/372fec9fd745b61fcc8760fc5af43423f405da142140bb2161035d9d38fc322b.png",
    "https://cdn.faire.com/fastly/60a52b2ac8cccbef9e5d5905318f13eceea9984abbdd8e24675184a278b737cb.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Notes: Papyrus, Cardamom, Cedar, Violet Leaf, Blooming Iris\n\nGolden hour strikes again while waiting for dusk to arrive. Smoked out sunset in view. Violet leaves in glass vases sleep on cedar planks. Warm spice lingers in the air for one last song.\n\nThis 7.75 oz candle is comprised of a premium soy wax blend and fine fragrance oils (all are Prop 65 and I.F.R.A. approved). Each candle comes complete with a braided cotton wick which burns cleanly for 40-50 hours.\n\nMeasurements:\n\nBox Size: 2.9" L X 2.9" W X 3.3" H\n\nCandle Size: 2.9" D X 3.25" H',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:59.210Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
